module.exports = __webpack_public_path__ + "assets/img/1.f6b8ef1c.png";